import { render, staticRenderFns } from "./waitServiceOrArrive.vue?vue&type=template&id=4912e4cc&scoped=true"
import script from "./waitServiceOrArrive.vue?vue&type=script&lang=js"
export * from "./waitServiceOrArrive.vue?vue&type=script&lang=js"
import style0 from "./waitServiceOrArrive.vue?vue&type=style&index=0&id=4912e4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4912e4cc",
  null
  
)

export default component.exports